import { AdminDashboard } from "@root/components/adminDashboard/AdminDashboard";
import { ROUTE_NAMES } from "@root/constants";
import { GlobalContextProvider } from "@root/context/global-context";
import AdminLayout from "@root/layouts/AdminLayout";
import { AdminAnalyticsScreen } from "@root/pages/admin-analytics";
import { AdminUserManagementScreen } from "@root/pages/admin-user-management";
import { AdminBrandingScreen } from "@root/pages/admin-branding";
import { createBrowserRouter, Navigate } from "react-router-dom";

export const adminRoutes = createBrowserRouter([
  {
    path: "/admin",
    element: (<GlobalContextProvider><AdminLayout /></GlobalContextProvider>),
    children: [
      {
        path: "",
        element: <Navigate to={ROUTE_NAMES.ADMIN_USER_MANAGEMENT} />,
      },
      {
        path: ROUTE_NAMES.ADMIN_USER_MANAGEMENT,
        element: <AdminUserManagementScreen />,
      },
      {
        path: ROUTE_NAMES.ADMIN_BRANDING,
        element: <AdminBrandingScreen />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={ROUTE_NAMES.ADMIN_USER_MANAGEMENT} />,
  },
]);
